:root {
  --add-ons-interaction-30: hsl(204, 100%, 30%);
  --add-ons-interaction-40: hsl(204, 100%, 35%);
  --add-ons-interaction-50: hsl(204, 100%, 40%); /* base */
  --add-ons-interaction-60: hsl(204, 95%, 75%);
  --add-ons-interaction-70: hsl(204, 95%, 89%);
  --add-ons-interaction-80: hsl(204, 95%, 94%);
  --add-ons-interaction-90: hsl(204, 95%, 97%);

  --add-ons-success-30: hsl(97, 57%, 23%);
  --add-ons-success-40: hsl(97, 57%, 28%);
  --add-ons-success-50: hsl(97, 57%, 33%); /* base */
  --add-ons-success-60: hsl(97, 57%, 40%);
  --add-ons-success-70: hsl(97, 40%, 60%);
  --add-ons-success-80: hsl(97, 57%, 90%);
  --add-ons-success-90: hsl(97, 60%, 95%);

  --add-ons-warning-30: hsl(42, 84%, 49%);
  --add-ons-warning-40: hsl(42, 84%, 55%);
  --add-ons-warning-50: hsl(42, 84%, 63%); /* base */
  --add-ons-warning-60: hsl(42, 87%, 70%);
  --add-ons-warning-70: hsl(42, 87%, 80%);
  --add-ons-warning-80: hsl(42, 87%, 90%);
  --add-ons-warning-90: hsl(42, 87%, 94%);

  --add-ons-danger-30: hsl(9, 60%, 40%);
  --add-ons-danger-40: hsl(8, 60%, 45%);
  --add-ons-danger-50: hsl(8, 60%, 47%); /* base */
  --add-ons-danger-60: hsl(8, 60%, 64%);
  --add-ons-danger-70: hsl(8, 60%, 75%);
  --add-ons-danger-80: hsl(8, 60%, 85%);
  --add-ons-danger-90: hsl(9, 60%, 93%);

  --add-ons-legacy-brand-25: hsl(218, 84%, 25%);

  --add-ons-legacy-brand-62: hsl(221, 91%, 62%);
  --add-ons-legacy-brand-87: hsl(221, 91%, 87%);

  --add-ons-legacy-create-23: hsl(86 91% 23%);
  --add-ons-legacy-create-25: hsl(86 91% 25%);
  --add-ons-legacy-create-27: hsl(86 91% 27%);
  --add-ons-legacy-create-35: hsl(86 91% 35%);
  --add-ons-legacy-create-91: hsl(95 50% 91%);
  --add-ons-legacy-create-97: hsl(93 53% 97%);

  --add-ons-legacy-delete-47: hsl(8, 60%, 47%);
  --add-ons-legacy-delete-45: hsl(8, 60%, 45%);
  --add-ons-legacy-delete-43: hsl(8, 60%, 43%);
  --add-ons-legacy-delete-93: hsl(9, 59%, 93%);
  --add-ons-legacy-delete-97: hsl(7, 60%, 97%);

  --add-ons-legacy-warning-49: hsl(42, 84%, 49%);
  --add-ons-legacy-warning-55: hsl(42, 84%, 55%);
  --add-ons-legacy-warning-63: hsl(42, 84%, 63%);
  --add-ons-legacy-warning-90: hsl(42, 87%, 90%);
  --add-ons-legacy-warning-94: hsl(42, 87%, 94%);
  --add-ons-legacy-warning-97: hsl(42, 87%, 97%);
  --add-ons-legacy-warning-text: hsl(36, 100%, 31%);

  --add-ons-naked-input-background: var(--t-fill-color-neutral-070);
}
